import styled from 'styled-components';
import React, { useContext } from 'react';
import { SiteHeaderContext } from './SiteHeaderContext';
import { ScreenReaderOnly } from '../../a11y/ScreenReaderOnly';

const StyledHamburgerButton = styled.button`
   cursor: pointer;
   background-color: transparent;
   border: none;
   padding: 0 1.5rem;
   border-right: 1px solid #003c69;
   margin-right: -2rem;
   outline: none;

   & > span,
   & > span::after,
   & > span::before {
      position: relative;
      display: block;
      background-color: ${({ theme }) => theme.brandColors.white};
      width: 1.5rem;
      height: 2px;
      transition: transform 0.5s ease, background 0.5s ease;
   }

   & > span::after,
   & > span::before {
      content: '';
      position: absolute;
   }

   & > span::before {
      bottom: -7px;
   }

   & > span::after {
      top: -7px;
   }

   :hover,
   :focus {
      outline: none;

      & > span,
      & > span::after,
      & > span::before {
         background-color: ${({ theme }) => theme.semanticColors.secondary};
      }
   }
`;

const TopNavHamburgerButton = () => {
   const { mobileMenuOpen, setMobileMenuOpen } = useContext(SiteHeaderContext);

   return (
      <StyledHamburgerButton
         data-rcl-hamburger-button
         onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      >
         <span>
            <ScreenReaderOnly>{`${
               mobileMenuOpen ? 'Close' : 'Open'
            } Navigation Menu`}</ScreenReaderOnly>
         </span>
      </StyledHamburgerButton>
   );
};

export { TopNavHamburgerButton };
